import React from 'react';

import { Typography } from '@mui/material';
import { useEditorSuggestionState } from 'src/editor/editor-suggestion-state-registry';
import { makeStyles } from 'tss-react/mui';

import { useSelectedSuggestionUnit } from './useNavigationHooks';

const useStyles = makeStyles()(theme => ({
  container: {
    alignItems: 'flex-start',
    display: 'flex',
    gap: theme.spacing(1),
    minWidth: 0,
  },
  reasoningLabel: {
    fontStyle: 'italic',
    textDecoration: 'underline',
  },
  title: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
}));

export function SuggestionsAlertStatus(): JSX.Element {
  const { classes } = useStyles();
  const { suggestionUnits } = useEditorSuggestionState();
  const { selectedSuggestionUnit } = useSelectedSuggestionUnit();

  if (selectedSuggestionUnit) {
    /**
     * In-paragraph edits store reasoning on the marker start element; block
     * suggestions store it on the first sourced edit of the group. The unit
     * carries the first one found either way.
     */
    const reasoning =
      selectedSuggestionUnit.marker?.start.reasoning || selectedSuggestionUnit.reasoning;

    return (
      <div className={classes.container}>
        <Typography className={classes.title} variant="body2">
          {reasoning ? (
            <>
              <span className={classes.reasoningLabel}>AI Reasoning:</span> {reasoning}
            </>
          ) : (
            'AI Edit'
          )}
        </Typography>
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <Typography className={classes.title} variant="subtitle2">
        {`${suggestionUnits.length} unhandled AI ${suggestionUnits.length === 1 ? 'edit' : 'edits'} in document`}
      </Typography>
    </div>
  );
}
